module.exports = __webpack_public_path__ + "img/logo_5.d35fe6af.png";